// extracted by mini-css-extract-plugin
export default {"collapse":"style_collapse__NZzOU"};